import React, { useEffect, useState, useMemo } from 'react';

import { ERROR_LEVELS, SENTRY_EPPO } from 'services/Sentry/constants';

import sentry from 'services/Sentry/SentryInstance';

import { initEppo } from './client';
import { getAbAutoTestsQuery } from 'services/Eppo/helpers';

export const EppoGate: React.FC<React.PropsWithChildren<{ fallback?: React.ReactNode }>> = ({
    children,
    fallback = null,
}) => {
    const { aqa } = useMemo(() => getAbAutoTestsQuery(), []);
    const [ready, setReady] = useState<boolean>(Boolean(aqa));

    useEffect(() => {
        if (aqa) return;

        initEppo()
            .catch((err) => {
                sentry.logError(err, SENTRY_EPPO, ERROR_LEVELS.ERROR);
            })
            .finally(() => setReady(true));
    }, [aqa]);

    return ready ? <>{children}</> : <>{fallback}</>;
};
